import { type ReactNode } from 'react';
import * as React from 'react';
import styled, { css } from 'styled-components';

import { CellFooter } from './CellFooter';
import { CellHeader, type CellHeaderStyle } from './CellHeader';
import { Card } from './SharedStyles';

export const DEFAULT_FIXED_HEIGHT = 200;

const Inner = styled(Card)<{ $fixedHeight?: number }>`
  width: 100%;
  padding: 0;
  z-index: 3;
  position: relative;
  flex: 1 1 auto;
  display: flex;

  ${({ $fixedHeight }) =>
    $fixedHeight &&
    css`
      height: ${$fixedHeight}px;
      overflow: hidden;
      flex: none;
    `}
`;

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 6px;
  position: relative;
`;

interface CellProps {
  children: ReactNode;
  commentPopupOverride?: boolean;
  disabled?: boolean;
  fixedHeight?: number;
  headerStyle?: CellHeaderStyle;
  hideHeader?: boolean;
  label: string;
  outputColor?: string;
  outputName?: string;
  showCommentCount?: boolean;
}

export const Cell: React.ComponentType<CellProps> = React.memo(
  ({
    children,
    commentPopupOverride = false,
    fixedHeight,
    disabled = true,
    showCommentCount,
    headerStyle = 'top',
    hideHeader = false,
    label,
    outputName,
    outputColor
  }) => {
    return (
      <Wrapper>
        {!hideHeader && (
          <CellHeader
            commentPopupOverride={commentPopupOverride}
            disabled={disabled}
            headerStyle={headerStyle}
            label={label}
            showCommentCount={showCommentCount}
          />
        )}
        <Inner $fixedHeight={fixedHeight}>{children}</Inner>
        {outputName && (
          <CellFooter outputColor={outputColor} outputName={outputName} />
        )}
      </Wrapper>
    );
  }
);
